import React, {useState, useEffect} from 'react';
import { Bar } from '@ant-design/plots';

const CustomerBaseChart = ({chartValue, chartData}) => {
    const [graphData, setGraphData] = useState([]);

    useEffect(() => {
        organizeData(chartData, chartValue);
    }, [chartData, chartValue]);

    const titles = {
        WAITING: 'BEKLEYEN',
        POSITIVE: 'OLUMLU',
        NEGATIVE: 'OLUMSUZ'
    };

    const typeTitles = {
        3: 'OLUMLU',
        4: 'OLUMSUZ',
        5: 'BEKLEYEN'
    };

    const chartValueTypes = {
        1: {
            xField: 'count',
            yField: 'status',
            tooltip: {
                formatter: (d) => {
                    return { name: d.status, value: Intl.NumberFormat().format(d.count) };
                }
            }
        },
        2: {
            xField: 'price',
            yField: 'status',
            tooltip: {
                formatter: (d) => {
                    return { name: d.status, value: Intl.NumberFormat().format(d.price) };
                }
            }
        },
        3: {
            xField: 'price',
            yField: 'status',
            tooltip: {
                formatter: (d) => {
                    return { name: d.status, value: Intl.NumberFormat().format(d.price) };
                }
            }
        },
        4: {
            xField: 'price',
            yField: 'status',
            tooltip: {
                formatter: (d) => {
                    return { name: d.status, value: Intl.NumberFormat().format(d.price) };
                }
            }
        },
        5: {
            xField: 'price',
            yField: 'status',
            tooltip: {
                formatter: (d) => {
                    return { name: d.status, value: Intl.NumberFormat().format(d.price) };
                }
            }
        }
    }

    const organizeData = (obj, type) => {
        const structured = [];
        for(const currency in obj) {
            const currencyItem = obj[currency];

            currencyItem.forEach(bid => {
                structured.push({
                    status: `${currency}-${titles[bid.bidStatus]}`,
                    count: bid.count || 0,
                    price: bid.priceWithTax || 0
                })
            })

        }

        if(type === 1 || type === 2) {
            setGraphData(structured);
            return;
        }

        const result = filterWithType(structured, typeTitles[type]);
        setGraphData(result);
    };

    const filterWithType = (arr, typeStr) => arr.filter((item) => (item.status).includes(typeStr));

    const chartConfig = {
        data: graphData,
        ...chartValueTypes[chartValue],
        seriesField: 'status',
        legend: {
          position: 'top-left',
        }
    };

    return(
        <React.Fragment>
            <Bar appendPadding={8} {...chartConfig}/>
        </React.Fragment>
    )
}

export default CustomerBaseChart;